
























import Vue from 'vue';
import SearchBox from '../components/search/SearchBox.vue';
import SearchSettings from '../components/search/SearchSettings.vue';
import SearchTable from '../components/search/SearchTable.vue';
import customerVuex from '../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    SearchBox,
    SearchSettings,
    SearchTable,
  },
  data() {
    return {
      canTableScrollY: false,
      onSearchMode: false,
      loaded: false,
    };
  },
  computed: {
    contentStyles(): any {
      return {
        height: this.contentHeight,
      };
    },
    notEmptySearch(): boolean {
      return !this.onSearchMode || this.customerState.customerList.total > 0;
    },
  },
  methods: {
    customerLoaded() {
      this.loaded = true;
      if (this.onSearchMode && this.customerState.customerList.total > 0) {
        (this.$refs.searchBox as any).setHistorySearchKeyword();
      }
    },
    redirectIfIE() {
      function checkIE() {
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
      }
      if (checkIE()) {
        window.location.href = '/not-supported';
      }
    },
  },
  beforeMount() {
    this.$store.commit('INIT_CUSTOMER_FILTER');
    this.$store.commit('INIT_CUSTOMER_QUERY');
  },
  mounted() {
    this.redirectIfIE();
    const appContent: any = window.document.getElementById('app-content');
    const el: any = window.document.querySelector('.customer-table .ivu-table-body');
    appContent.onscroll = (event: any) => {
      if (!this.customerState.showCustomerExport &&
          !this.customerState.showCustomerAnalyze && !this.customerState.showCustomerDetail) {
        event.preventDefault();
        if (appContent.scrollTop >= 160) {
          event.preventDefault();
          appContent.scrollTop = 160;
        }
        this.canTableScrollY = appContent.scrollTop === 160;
      }
    };
    appContent.onmousewheel =  (event: any) => {
      if (!this.customerState.showCustomerExport &&
          !this.customerState.showCustomerAnalyze && !this.customerState.showCustomerDetail) {
        event.preventDefault();
        appContent.scrollTop += event.deltaY;
        if (appContent.scrollTop > 160) {
          appContent.scrollTop = 160;
        }
        this.canTableScrollY = appContent.scrollTop === 160;
        el.scrollTop = 0;
      }
    };
  },
  beforeDestroy() {
    const appContent: any = window.document.getElementById('app-content');
    appContent.onscroll = (event: any) => {
      return true;
    };
    appContent.onmousewheel = (event: any) => {
      return true;
    };
  },
});
